import { getCookieItem } from "./useCookie";
import isAbsoluteUrl from "is-absolute-url";
import { extractPartnerReferralFromUrl } from "../utils"

export function getPartnerCode(locationSearch: string): { code: string; programCode?: string } | undefined {
    const urlPartnerCode = extractPartnerReferralFromUrl(locationSearch)
    if (urlPartnerCode) {
        return urlPartnerCode;
    }

    var partnerCode = getCookieItem('seeka_partner_key');
    var partnerProgram = getCookieItem('seeka_partner_program');

    return partnerCode ? { code: partnerCode, programCode: partnerProgram || undefined } : undefined
}

export function getPartnerLink(initialUrl: string | undefined, location: Location | undefined) {
    if (!location) return initialUrl;

    var partner = getPartnerCode(location.search)

    const alreadyAdded = initialUrl && initialUrl.indexOf('partner=') > -1;

    if (!initialUrl || !isAbsoluteUrl(initialUrl) || !partner || alreadyAdded) return initialUrl;

    const separator = initialUrl.indexOf('?') > -1 ? '&' : '?';
    const programParam = partner.programCode ? `&partner_program=${partner.programCode}` : '';

    return `${initialUrl}${separator}partner=${partner.code}${programParam}`;
}